import React from "react"
import "./home.scss"
import Testemonials from "../Components/LandingPageComponents/Testemonials"
import CourseLeadFluency from "../Components/LandingPageComponents/CourseLeadFluency"
import VideoTestemonies from "../Components/LandingPageComponents/VideoTestemonies"
import CourseCardsGrid from "../Components/LandingPageComponents/CourseCardsGrid"
import MyProfile from "../Components/LandingPageComponents/MyProfile"
import EBook from "../Components/EBook"
import NewsletterSubscriptionForm from "../Components/Forms/NewsletterSubscriptionForm"
import NewsletterComponent from "../Components/Forms/NewsletterComponent"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"

function Home() {
  const location = useLocation()

  useEffect(() => {
    // Only scroll to top if there's no hash in the location
    if (!location.hash) {
      window.scrollTo(0, 0)
    }
  }, [location])
  
  return (
    <div className="home-page justify-center items-center flex flex-col w-full lg:min-w-[1000px] bg-gradient-to-br from-violet-600 via-indigo-600 to-purple-700 min-h-screen">
      {/* Hero Section - Enhanced */}
      <div className="hero-section-wrapper w-full relative overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
          <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8 lg:gap-12 max-w-7xl mx-auto">
            {/* Left Content */}
            <div className="lg:w-[55%] flex flex-col text-white gap-8 lg:gap-10">
              {/* E-book CTA */}
              <div className="hero-ebook-section flex flex-col gap-6 animate-fade-in">
                <div>
                  <span className="inline-block text-white text-base md:text-lg font-semibold tracking-wide uppercase opacity-90">
                    E-book Gratuito
                  </span>
                </div>
                <div>
                  <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white">
                    Desbloqueie sua Fluência em Inglês!
                  </h1>
                </div>
                <p className="text-lg md:text-xl text-white/90 leading-relaxed max-w-xl">
                  Guia prático e direto ao ponto para desbloquear sua fluência. Acesso imediato, sem compromissos.
                </p>
                <div className="mt-4">
                  <NewsletterSubscriptionForm button={"Obter E-book Grátis"} />
                </div>
              </div>
            </div>

            {/* Right Content - E-book Image */}
            <div className="lg:w-[45%] flex justify-center items-center animate-slide-in">
              <div className="ebook-image-wrapper">
                <EBook />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Section - Full Width */}
      <div className="section-wrapper w-full bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="hero-profile-section animate-fade-in-delay">
              <MyProfile />
            </div>
          </div>
        </div>
      </div>

      {/* Course Lead Fluency Section - Keep gradient, no white wrapper */}
      <div className="section-wrapper  w-full">
        <CourseLeadFluency />
      </div>

      {/* Merged Courses Section - Grid Layout */}
      <div id="course-cards" className="section-wrapper bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 w-full">
        <CourseCardsGrid />
      </div>

      {/* Testimonials Section - Gradient Background */}
      <div className="section-wrapper bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 w-full">
        <Testemonials />
      </div>

      {/* Video Testimonies - Gradient Background */}
      <div className="section-wrapper bg-white w-full">
        <VideoTestemonies />
      </div>

      {/* Footer Spacing */}
      {/* <div className="md:h-[10vh] h-[8vh]"></div> */}
      
      {/* Footer */}
      {/* <LandingFooter /> */}
      
      {/* Newsletter Component */}
      <NewsletterComponent />
    </div>
  )
}

export default Home
